import type { USER_TEAM_ROLE } from "@tastyworks/shared-utils/misc/constants"
import type HttpClient from "../../tastyworks/http"
import { parseSingleResponse } from "../../tastyworks/response"
import {
  USER_TEAMS_DESER,
  USER_TEAM_MEMBER_DESER,
  UserTeam,
  UserTeamMember,
} from "../../tastyworks/user-teams"

export class UserTeamService {
  private readonly userTeamClient: HttpClient

  constructor(
    private readonly baseHttpClient: HttpClient,
    private readonly userMeClient: HttpClient
  ) {
    this.userTeamClient = this.baseHttpClient.nested("user-teams")
  }

  async index() {
    return this.userMeClient.indexSimple(
      USER_TEAMS_DESER.toParser(UserTeam),
      "user-teams"
    )
  }

  async createMember(member: UserTeamMember) {
    return this.userTeamClient.create(
      member,
      USER_TEAM_MEMBER_DESER.serialize,
      USER_TEAM_MEMBER_DESER.update,
      "/:id/members",
      { id: member.teamId }
    )
  }

  async deleteMember(teamId: string, memberId: string) {
    return this.userTeamClient.destroy("/:teamId/members/:memberId", {
      teamId,
      memberId,
    })
  }

  async updateMemberRole(
    teamId: string,
    memberId: string,
    role: `${USER_TEAM_ROLE}`
  ) {
    const jsonHelper = await this.userTeamClient.patch(
      "/:teamId/members/:memberId",
      { role },
      { teamId, memberId }
    )
    return parseSingleResponse(
      jsonHelper,
      USER_TEAM_MEMBER_DESER.toParser(UserTeamMember)
    )
  }
}
